import { API_BASE } from '../config.js';

/**
 * เรียก Worker API — ทุก call เป็น POST /api body = { action, ...payload }
 * (แนวเดียวกับ HR Portal เดิม)
 */
export async function api(action, payload = {}) {
  const res = await fetch(`${API_BASE}/api`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action, ...payload }),
  });
  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error(`API ตอบไม่ใช่ JSON (status ${res.status})`);
  }
  if (!res.ok || data.ok === false) {
    throw new Error(data.error || `API error (status ${res.status})`);
  }
  return data;
}
